import Resource from './Resource';

export default class GlossaryEntries extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
			data = {}
		} = options;

		let config = {
			route: !routeParams.glossaryEntryID ? 'class-pages/:courseSectionGuid/:glossaryType/:glossaryID/entries'
																	: 'class-pages/:courseSectionGuid/:glossaryType/:glossaryID/entries/:glossaryEntryID',
			routeParams: routeParams,
			query: query,
			data: data,
		};

		super(config);
		return this;
	}

	post() {
		return this.request('post');
	}

	put() {
		return this.request('put');
	}

	delete() {
		return this.request('delete');
	}
}
